import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Redirect, withRouter } from 'react-router-dom';
import { checkUserSession, logOutUser } from '../../actions/user';
import Login from '../login';
import Dashboard from '../dashboard';
import Spinner from '../../components/spinner';
import PrivateRoute from '../../components/private-route';
import NavBar from '../../components/nav-bar';

class App extends React.Component{

  constructor(props) {
    super(props);

    this.onLogout = this.onLogout.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;
    dispatch(checkUserSession());
  }

  render() {
    const { user, location } = this.props;
    const isAuthenticated = !!user.sessionToken;

    if (user.isCheckingSession) {
      return <Spinner />;
    }

    return (
      <Router>
        <div>
          <NavBar isAuthenticated={ isAuthenticated } username={ user.username } onLogout={ this.onLogout }/>
          <Route exact path="/" render={() => (
            <Redirect to={{
              pathname: '/redigera',
              state: { from: location },
            }}/>
          )}/>
          <Route exact path="/logga-in" component={ Login }/>
          <PrivateRoute
            path="/redigera/:key?"
            redirectPath={ '/logga-in' }
            component={ Dashboard }
            isAuthenticated={ isAuthenticated }
          />
        </div>
      </Router>
    );
  }

  onLogout(/* event */) {
    const { dispatch } = this.props;
    dispatch(logOutUser());
  }
}

App.propTypes = {
  user: PropTypes.object.isRequired,
  location: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./client/src/containers/app/index.js